import React, { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/esm/Alert';
import Button from 'react-bootstrap/esm/Button';
import Spinner from 'react-bootstrap/esm/Spinner';
import { Api } from '../../api';
import { ResponsiveTable, ResponsiveTableColumn } from '../../features/responsive-table/ResponsiveTable';
import { NotificationHelper } from '../../helpers/NotificationHelper';
import { TFormSubmissionsList } from '../../models/LibraryFormSubmissionList';
import { LibrarySubmissionDetail } from './LibrarySubmissionDetail';
import { useHistory } from 'react-router';
import './Library.scss';

interface ILibrarySubmissionProps {
  dossierRelationId: number;
}

interface IDataFormat {
  name: string|null;
  createdAt: string|null;
  seeResult: JSX.Element|null;
}

const columns: ResponsiveTableColumn<IDataFormat>[] = [
  { title: 'Titel formulier', objectKey: 'name', width: '22rem', disableSort: true },
  { title: 'Datum ingevuld', objectKey: 'createdAt', width: '11rem', disableSort: true },
  { title: '', objectKey: 'seeResult', width: '8rem', disableSort: true },
];

export function LibrarySubmissionList(props: ILibrarySubmissionProps): JSX.Element {
  const { dossierRelationId } = props;
  const [librarySubmissionList, setLibrarySubmissionList] = useState<TFormSubmissionsList>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<IDataFormat[]>([]);
  const [openDetail, setOpenDetail] = useState<number|null>(null);
  const history = useHistory();

  useEffect(() => {
    setOpenDetail(null);
    if (!dossierRelationId) {
      return;
    }

    Api.getLibraryFormSubmissionsList(dossierRelationId)
      .then(items => setLibrarySubmissionList(items))
      .catch(err => {
        console.error(err);
        NotificationHelper.toastError('Ophalen antwoorden mislukt, probeer het later opnieuw.');
      })
      .finally(() => setLoading(false));
  }, [dossierRelationId]);

  useEffect(() => {
    const newData: IDataFormat[] = [];
    const formIds = Object.keys(librarySubmissionList);
    formIds.forEach(formId => {
      const submissionListItem = librarySubmissionList[formId];
      const { name, submissions } = submissionListItem;
      const items: IDataFormat[] = submissions.map(submission => ({
        name: null,
        createdAt: submission.createdAt.toLocaleString('nl'),
        seeResult: <Button
          variant="link"
          className="library-submissions__results"
          onClick={() => setOpenDetail(submission.id)}
        >
          Toon resultaten
        </Button>
      }));
      newData.push({ name, createdAt: null, seeResult: null }, ...items);
      setData(newData);
    });
  }, [librarySubmissionList, history]);

  const renderDetails = () => {
    if (openDetail === null) {
      return <Alert variant="info">Selecteer een resultaat</Alert>;
    }
    return <>
      <LibrarySubmissionDetail submissionId={openDetail}></LibrarySubmissionDetail>
    </>;
  };

  const renderSubmissions = (): JSX.Element => <ResponsiveTable<IDataFormat> columns={columns} data={data}/>;

  return (
    <>
      { openDetail !== null ? renderDetails() : renderSubmissions() }
      { loading && <Spinner animation="border" variant="primary" /> }
    </>
  );
}
